import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import BsModal from 'ember-bootstrap/components/bs-modal';

interface GoalDeleteModalSignature {
  Args: {
    deleting: boolean;
    onConfirm: () => void | Promise<void>;
  };
  Blocks: {
    default: [showModal: () => void];
  };
}

export default class GoalDeleteModal extends Component<GoalDeleteModalSignature> {
  @tracked open = false;

  showModal = () => {
    this.open = true;
  };

  closeModal = () => {
    if (!this.args.deleting) {
      this.open = false;
    }
  };

  confirm = async () => {
    await this.args.onConfirm();
    this.open = false;
  };

  <template>
    {{#if this.open}}
      <BsModal @open={{this.open}} as |modal|>
        <modal.header>
          <h2 class="modal-title h5">Delete goal?</h2>
        </modal.header>
        <modal.body>
          <p class="mb-0">This goal, its milestones, and its reflections will be
            permanently deleted. This cannot be undone.</p>
        </modal.body>
        <modal.footer>
          <button
            type="button"
            class="btn btn-outline-primary"
            disabled={{@deleting}}
            {{on "click" this.closeModal}}
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            disabled={{@deleting}}
            data-test-goal-delete-confirm
            {{on "click" this.confirm}}
          >
            {{if @deleting "Deleting…" "Delete goal"}}
          </button>
        </modal.footer>
      </BsModal>
    {{/if}}

    {{yield this.showModal}}
  </template>
}
